import Index from "views/Index.js";
import Profile from "views/examples/Profile.js";
import Register from "views/examples/Register.js";
import Login from "views/examples/Login.js";
import PublicResult from "views/public/publicResult";
import AdminManagement from "views/examples/AdminManagement";
import StudentManagement from "views/examples/StudentManagement";
import TeacherManagement from "views/examples/TeacherManagement";
import AttendanceManagement from "views/examples/AttendanceManagement";
import LeaveManagement from "views/examples/LeaveManagement";
import FinanceManagement from "views/examples/FinanceManagement";


import StudentDetail from "views/examples/StudentDetails";
import ForgotPassword from "views/examples/ForgetPassword";
import ResetPassword from "views/examples/ResetPassword";
import AcademicProgressManagement from "views/examples/AcademicProgressManagement";
import SuperAdminManagement from "views/examples/SuperAdmins"

import TeacherLeave from "views/examples/TeacherLeave";
import TeacherDetail from "views/examples/TeacherDetail";
import Dashboard from "views/Dashboard/Index";
import Academics from "views/examples/Academics";
import Configuration from "views/examples/AdminConfig";
import GradeSystem from "views/examples/GradeSystem";
import LeaveTypes from "views/examples/LeaveType";
import LeaveQuota from "views/examples/LeaveQuota";
import MarkAttendance from "views/examples/TeacherAttendance";
import AddStudentAttendace from "views/examples/AddStudentAttendace";
import AttendanceOverview from "views/examples/ViewAllAttendance";
import StudentAttendance from "views/examples/StudentAttendance";
import OvertimeRequests from "views/examples/Overtime";
import DonationCategory from "views/examples/DonationCategory";
import GeneralSettings from "views/examples/SchoolSetting";
import ExpenseCategory from "views/examples/ExpenseCategory";
import SalaryManagement from "views/examples/SalaryCategory";
import FeeView from "views/examples/StudentFee";
import SalaryPolicy from "views/examples/SalaryPolicy";
import TeacherSalary from "views/examples/TeacherSalary";
import AddTeacher from "views/examples/TeacherInfo";
import TeacherSalaryDetails from "views/examples/TeacherOwnSalary";
import AddExam from "views/examples/AddExam"
import ViewExam from "views/examples/ViewExam"
import EditExam from "views/examples/EditExam"
import StudentExamList from "views/examples/StudentExam"


import TeacherExamList from "views/examples/TeacherExam"
import SubjectResult from "./views/examples/SubjectResult"
import AddSubjectResult from "./views/examples/AddResult"
import ViewSubjectResult from "views/examples/ViewSubjectResult";
import ViewStudentResult from "views/examples/SingleStudentResult";

import ExamType from "views/examples/ExamType";
import PromoteStudents from "views/examples/PromotedStudents";
import StudentResultPage from "views/examples/StudentResult";

import TeacherSubjectResultPage from "views/examples/TeacherSubjectResult";
import StudentMonthlyFee from "views/examples/StudentMonthlyFee";



import OpeningBalanceManagement from "views/examples/OpeningBalance";
var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-red",
    component: <Dashboard />,
    layout: "/admin",
    showInSidebar: true
  },
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-red",
    component: <Dashboard />,
    layout: "/staff",
    showInSidebar: true

  },
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-red",
    component: <Dashboard />,
    layout: "/student",
    showInSidebar: true

  },
  {
    path: "/user-profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
    showInSidebar: true

  },
  {
    path: "/admin-mangement",
    name: "Admin Management",
    icon: "ni ni-istanbul text-red",
    component: <AdminManagement />,
    layout: "/admin",
    showInSidebar: true

  },
  {
    path: "/admin-mangements",
    name: "Admin Management",
    icon: "ni ni-hat-3 text-red",
    component: <SuperAdminManagement />,
    layout: "/admin",
    showInSidebar: true

  },

  {
    path: "/student-mangement",
    name: "Student Management",
    icon: "ni ni-hat-3 text-red",
    component: <StudentManagement />,
    layout: "/admin",
    showInSidebar: true

  },
  {
    path: "/teacher-mangement",
    name: "Staff Management",
    icon: "ni ni-single-02 text-red",
    component: <TeacherManagement />,
    layout: "/admin",
    showInSidebar: true

  },
  {
    path: "/attendance-mangement",
    name: "Attendance Management",
    icon: "ni ni-paper-diploma text-red ",
    component: <AttendanceOverview />,
    layout: "/admin",
    showInSidebar: true

  },

  {
    path: "/attendance-mangement",
    name: "View Attendance",
    icon: "ni ni-paper-diploma text-red ",
    component: <StudentAttendance />,
    layout: "/student",
    showInSidebar: true

  },
  {
    path: "/leave",
    name: "Leave Managment",
    icon: "ni ni-user-run text-red ",
    component: <TeacherLeave />,
    layout: "/student",
    showInSidebar: true

  },

  {
    path: "/attendance-mangement",
    name: "Student Attendance",
    icon: "ni ni-paper-diploma text-red ",
    component: <AddStudentAttendace />,
    layout: "/staff",
    showInSidebar: true

  },
  {
    path: "/monthly-fee",
    name: "Student Monthly Fee",
    icon: "ni ni-hat-3 text-red",
    component: <StudentMonthlyFee />,
    layout: "/admin",
    showInSidebar: true

  },
  {
    path: "/add-attendance",
    name: "Add Attendance",
    icon: "ni ni-paper-diploma text-red ",
    component: <MarkAttendance />,
    layout: "/staff",
    showInSidebar: true

  },
  {
    path: "/teacher-leave",
    name: "Leave Managment",
    icon: "ni ni-user-run text-red ",
    component: <TeacherLeave />,
    layout: "/staff",
    showInSidebar: true
  },
  {
    path: "/teacher-exam-sch",
    name: "Exam List",
    icon: "ni ni-user-run text-red ",
    component: <TeacherExamList />,
    layout: "/staff",
    showInSidebar: true
  },
  //
  {
    path: "/payroll-mangement",
    name: "View Payroll",
    icon: "ni ni-paper-diploma text-red ",
    component: <TeacherSalaryDetails />,
    layout: "/staff",
    showInSidebar: true

  },
  {
    path: "/subject-resut",
    name: "Subject Result",
    icon: "ni ni-paper-diploma text-red ",
    component: <TeacherSubjectResultPage />,
    layout: "/staff",
    showInSidebar: true

  },

  // {TeacherSalaryDetails
  //   path: "/payroll-mangement",
  //   name: "View Payroll",
  //   icon: "ni ni-paper-diploma text-red ",
  //   component: <AcademicProgressManagement />,
  //   layout: "/staff",
  //   showInSidebar: true

  // },


  {
    path: "/leave-mangement",
    name: "Leave Management",
    icon: "ni ni-user-run text-red ",
    component: <LeaveManagement />,
    layout: "/admin",
    showInSidebar: true

  },
  {
    path: "/overt-time-req",
    name: "Overtime Request",
    icon: "ni ni-user-run text-red ",
    component: <OvertimeRequests />,
    layout: "/admin",
    showInSidebar: true

  },
  {
    path: "/academis",
    name: "Academics Management",
    icon: "ni ni-books text-red ",
    component: <Academics />,
    layout: "/admin",
    showInSidebar: true

  },
  {
    path: "/finance-mangement",
    name: "Finance Management",
    icon: "ni ni-money-coins text-red",
    component: <FinanceManagement />,
    layout: "/admin",
    showInSidebar: true

  },
  // {
  //   path: "/academic-progress-mangement",
  //   name: "Academic Progress Management",
  //   icon: "ni ni-user-run text-red ",
  //   component: <AcademicProgressManagement />,
  //   layout: "/student",
  //   showInSidebar: true

  // },
  {
    path: "/fee-mangement",
    name: "Fee Management",
    icon: "ni ni-user-run text-red ",
    component: <FeeView />,
    layout: "/student",
    showInSidebar: true

  },
  {
    path: "/student-exam",
    name: "Student Exam",
    icon: "ni ni-user-run text-red ",
    component: <StudentExamList />,
    layout: "/student",
    showInSidebar: true
  },
  {
    path: "/student-result",
    name: "Result",
    icon: "ni ni-user-run text-red ",
    component: <StudentResultPage />,
    layout: "/student",
    showInSidebar: true
  },
  //
  // { //
  //   path: "/academic-progress-mangement",
  //   name: "Academic Progress Management",
  //   icon: "ni ni-user-run text-red ",
  //   component: <AcademicProgressManagement />,
  //   layout: "/staff",
  // },


  // {
  //   path: "/academic-progress-mangement",
  //   name: "Academic Progress Management",
  //   icon: "ni ni-user-run text-red ",
  //   component: <AcademicProgressManagement />,
  //   layout: "/staff",
  //   showInSidebar: true

  // },
  {
    path: "/academic-progress-mangement",
    name: "Academic Progress Management",
    icon: "ni ni-user-run text-red ",
    component: <AcademicProgressManagement />,
    layout: "/admin",
    showInSidebar: true

  },

  {
    path: "/configuartion",
    name: "Configuration",
    icon: "ni ni-books text-red ",
    component: <Configuration />,
    layout: "/admin",
    showInSidebar: true

  },
  {
    path: "/grade-system",
    component: <GradeSystem />,
    layout: "/admin",
    showInSidebar: false

  },
  //
  // {
  //   path: '/donation_management',
  //   name: 'Donation Management',
  //   icon: 'ni ni-money-coins text-red',

  //   component: <DonationManagement />,
  //   layout: '/admin',
  // },
  // {
  //   path: "/academic-progress-mangement",
  //   name: "Academic Progress Management",
  //   icon: "ni ni-user-run text-red",
  //   component: <AcademicProgressManagement />,
  //   layout: "/parent",
  //   showInSidebar: true

  // },

  {
    path: "/student-details/:id",
    // name: "Leave Management", CreateTeacher
    // icon: "ni ni-user-run text-red ",
    component: <StudentDetail />,
    layout: "/admin",
    showInSidebar: false

  },
  {
    path: "/AddTeacher/:id",
    // name: "teacheer sample",
    // icon: "ni ni-user-run text-red ",
    component: <AddTeacher />,
    layout: "/admin",
    showInSidebar: false


  },
  {
    path: "/AddTeacher/:id",
    // name: "teacheer sample",
    // icon: "ni ni-user-run text-red ",
    component: <AddTeacher />,
    layout: "/admin",
    showInSidebar: false


  },
  {
    path: "/staff-details/:id",
    // name: "Leave Management",
    // icon: "ni ni-user-run text-red ",
    component: <TeacherDetail />,
    layout: "/admin",
    showInSidebar: false

  },
  // {
  //   path: "/classes-mangement",
  //   name: "Classes Management",
  //   icon: "ni ni-single-02 text-red",
  //   component: <ClassesManagement />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/organization-mangement",
  //   name: "Organization Management",
  //   icon: "ni ni-money-coins text-success",
  //   component: <OrganizationManagement />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/organization-detail",
  //   name: "Organization Detail",
  //   icon: "fas fa-users text-orange",
  //   component: <OrganizationDetail />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/user-mangement",
  //   name: "User Management",
  //   icon: "fas fa-users text-orange",
  //   component: <UserManagement />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/device-mangement",
  //   name: "Device Management",
  //   icon: "ni ni-tablet-button text-primary",
  //   component: <DeviceManagement />,
  //   layout: "/admin",
  // },
  // {
  //   path: "/device-details",
  //   name: "Device Details",
  //   icon: "ni ni-tablet-button text-primary",
  //   component: <DeviceDetails />,
  //   layout: "/admin",
  // },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
    showInSidebar: true
  },

  {
    path: "/resetPassword",
    name: "resetPassword",
    icon: "ni ni-key-25 text-info",
    component: <ResetPassword />,
    layout: "/auth",
    showInSidebar: true

  },
  {
    path: "/forgot-password",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <ForgotPassword />,
    layout: "/auth",
    showInSidebar: true

  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: <Register />,
    layout: "/auth",
    showInSidebar: true

  },


  {
    path: "/leave-types",
    component: <LeaveTypes />,
    layout: "/admin",
    showInSidebar: false

  },
  {
    path: "/leave-quota",
    component: <LeaveQuota />,
    layout: "/admin",
    showInSidebar: false

  },
  {
    path: "/donation-category",
    component: <DonationCategory />,
    layout: "/admin",
    showInSidebar: false

  },
  {
    path: "/school-setting",
    component: <GeneralSettings />,
    layout: "/admin",
    showInSidebar: false

  },
  {
    path: "/expense-category",
    component: <ExpenseCategory />,
    layout: "/admin",
    showInSidebar: false

  },
  {
    path: "/salary-category",
    component: <SalaryManagement />,
    layout: "/admin",
    showInSidebar: false
  },

  {
    path: "/salary-att-policy",
    component: <SalaryPolicy />,
    layout: "/admin",
    showInSidebar: false
  },

  {
    path: "/opening-balance",
    component: <OpeningBalanceManagement />,
    layout: "/admin",
    showInSidebar: false
  },

  {
    path: "/teacher-salary",
    component: <TeacherSalary />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/add-exam",
    component: <AddExam />,
    layout: "/admin",
    showInSidebar: false
  },

  {
    path: "/view-exam/:id",
    component: <ViewExam />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/add-subject-result/:classId/:subjectId/:examId",
    component: <AddSubjectResult />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/view-subject-result/:classId/:subjectId/:type/:year",
    component: <ViewSubjectResult />,
    layout: "/admin",
    showInSidebar: false
  },

  {
    path: "/subject-result/:id",
    component: <SubjectResult />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/exam-type",
    component: <ExamType />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/promote-students",
    component: <PromoteStudents />,
    layout: "/admin",
    showInSidebar: false
  },

  {
    path: "/view-student-result/:studentId/:type/:year",
    component: <ViewStudentResult />,
    layout: "/admin",
    showInSidebar: false
  },
  {
    path: "/edit-exam/:id",
    component: <EditExam />,
    layout: "/admin",
    showInSidebar: false
  },

];
export default routes;
